import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { ButtonWithIcon } from '@els/els-react--button';
import { Flyout } from '@els/els-react--flyout';
import { PRICE_SORT_UNAVAILABLE_TOOLTIP } from './constants';

import './SubstanceCommercialSupplierPriceSortTooltip.scss';

function SubstanceCommercialSupplierPriceSortTooltip({ id }) {
  return (
    <Flyout
      className="rcs-commercial-price-sort-tooltip u-els-margin-left-1o4"
      flyout={<div className="rcs-commercial-price-sort-tooltip__content">{PRICE_SORT_UNAVAILABLE_TOOLTIP}</div>}
      id={id}
      placement="top-end"
      pointerType="primary"
      shouldCloseOnESC
      theme="simple"
      trigger="click">
      <ButtonWithIcon
        aria-label="Price sorting information"
        data-e2e="commercial-supplier-price-sort-info"
        iconOnly
        linkIconSize="xs"
        onClick={noop}
        sprite="InformationOutlineCircle"
        type="link">
        Price sorting information
      </ButtonWithIcon>
    </Flyout>
  );
}

SubstanceCommercialSupplierPriceSortTooltip.propTypes = {
  id: PropTypes.string.isRequired,
};

export default SubstanceCommercialSupplierPriceSortTooltip;
